import * as React from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
    list: {
        display: 'grid',
        gridTemplateColumns: 'minmax(120px, 160px) minmax(0, 1fr)',
        columnGap: '16px',
        rowGap: '0',
        margin: 0,
        '@media (max-width: 767px)': {
            gridTemplateColumns: 'minmax(0, 1fr)',
        },
    },
    term: {
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
        borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
        '@media (max-width: 767px)': {
            paddingBottom: '0',
        },
    },
    details: {
        margin: 0,
        paddingTop: '10px',
        paddingBottom: '10px',
        minWidth: 0,
        overflowWrap: 'anywhere',
        borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
        fontSize: tokens.fontSizeBase300,
        '@media (max-width: 767px)': {
            borderTop: 'none',
            paddingTop: '4px',
        },
    },
    first: {
        borderTop: 'none',
    },
    mono: {
        fontFamily: tokens.fontFamilyMonospace,
        fontSize: tokens.fontSizeBase200,
    },
    inline: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        flexWrap: 'wrap',
    },
});

export interface IDescriptionItem {
    term: string;
    details: React.ReactNode;
    mono?: boolean;
}

const DescriptionList: React.FC<{ items: IDescriptionItem[] }> = ({ items }) => {
    const styles = useStyles();
    return (
        <dl className={styles.list}>
            {items.map((item, index) => (
                <React.Fragment key={item.term}>
                    <dt className={mergeClasses(styles.term, index === 0 && styles.first)}>{item.term}</dt>
                    <dd className={mergeClasses(styles.details, index === 0 && styles.first, item.mono && styles.mono)}>
                        {item.details ?? '—'}
                    </dd>
                </React.Fragment>
            ))}
        </dl>
    );
};

/** Helper for values with a trailing action button (copy, open). */
export const InlineValue: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const styles = useStyles();
    return <span className={styles.inline}>{children}</span>;
};

export default DescriptionList;
